export default "/_next/static/chunks/fonts/lato-100-6219d77f765dee38fd8704eedfa56801.woff2";